import { AnimatePresence } from 'motion/react';

import CliDock from './CliDock';
import CliSessionPicker from './CliSessionPicker';
import { useCliDock } from './cliSessionStore';

function CliDockHost() {
  const { sessions, picking, authFor } = useCliDock();

  return (
    <>
      <AnimatePresence>
        {Boolean(sessions.length) && <CliDock key="cli-dock" />}
      </AnimatePresence>
      <AnimatePresence>
        {picking && (
          <CliSessionPicker
            key="cli-picker"
            sessions={sessions}
            authFor={authFor}
          />
        )}
      </AnimatePresence>
    </>
  );
}

export default CliDockHost;
